<template>
  <!-- <div
    class="py-1 rounded-[20px] center-content text-sm font-medium"
    :class="{
      'bg-estationsGreen-100 text-estationsGreen-700': theme == 'Success',
      'bg-red-100 text-red-500': theme == 'Failed',
    }"
  >
    {{ statusText }}
  </div> -->

  <p class="px-4 py-1 rounded-full w-fit" :class="theme">
    {{ salesType }}
  </p>
</template>

<script>
export default {
  props: {
    salesType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      theme: "",
    };
  },
  mounted() {
    let salesType = this.salesType.trim().toLowerCase();
    if (salesType == "voucher" || salesType == "pending") {
      this.theme = "text-purple-500  bg-purple-50";
    } else if (salesType == "retainership" || salesType == "draft") {
      this.theme = "bg-brown-50 brown-500";
    } else if (salesType == "remis") {
      this.theme = "bg-blue-50 blue-500";
    } else if (salesType == "ussd" || salesType == "part paid") {
      this.theme = "bg-yellow-50 text-yellow-500";
    } else if (
      salesType == "debit" ||
      salesType == "overdue" ||
      salesType == "due"
    ) {
      this.theme = "bg-red-50 text-red-500";
    } else if (salesType === "approved" || salesType === "fulfilled") {
      this.theme = "bg-estationsGreen-50 text-estationsGreen-500";
    } else {
      this.theme = "bg-estationsGreen-50 text-estationsGreen-500";
    }
  },
};
</script>

<style></style>
